import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
const borderColor = '#ff8728'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#ff8728',
        borderBottomWidth: 0,
        alignItems: 'center',
        fontStyle: 'bold',
        paddingTop : '4px'
    },
    description: {
        width: '60%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        paddingLeft: 8,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'right',
        paddingRight: 8,
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 0,
        textAlign: 'right',
        paddingRight: 8,
    },
    amount: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const InvoiceTableRow = ({items}) => {
    
    const rows = items.map( item => 
        <View style={styles.row} key={item.articulo.articulos_id.toString()} >
        {
            item.Observaciones !=="" ? <Text style={styles.description}>{item.articulo.descri + "\n Observacion: " + item.Observaciones}</Text>:
            <Text style={styles.description}>{item.articulo.descri}</Text> 
        }
        <Text style={styles.qty}>{item.Cantidad}</Text>
        <Text style={styles.rate}>{item.Precio}</Text>
        <Text style={styles.amount}>{(item.Cantidad * item.Precio).toFixed(2)}</Text>
        </View>
    )
    
    
    return (<Fragment>{rows}</Fragment> )
};
  
export default InvoiceTableRow